import { User } from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for User context
const USER_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'user',
  format: 'jsonschema',
  version: '1-0-3',
}

export type UserContextSchemaData = {
  position?: number // An index position of post on the screen. Ads post is excluded from this context.
  user_id?: number // A Yay user ID
  gender?: number
  age?: number
  follower_number?: number
  following_number?: number
  account_create_at_time?: string | null // Account creation timestamp. Null for the users without account.
  is_verifiy_account?: boolean // A Boolean value indicate if this account is age verified or not.
}

export const userContextSchema = (
  data: UserContextSchemaData
): ContextSchema<UserContextSchemaData> => ({
  schema: schemaPath(USER_SCHEMA),
  data,
})

export const userToUserContextSchemaData = ({
  user,
  age,
  position,
}: {
  user?: Partial<User>
  age?: number
  position?: number
}): UserContextSchemaData => {
  if (!user?.id) return

  return {
    position,
    user_id: user.id,
    gender: user.gender,
    age,
    follower_number: user.followers_count,
    following_number: user.followings_count,
    account_create_at_time: user.created_at?.toString(),
    is_verifiy_account: user.age_verified,
  }
}
